var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center alarm-item"},[_c('div',{staticClass:"alarm-item__oval p-md-4 p-3"},[_c('img',{attrs:{"src":_vm.item?.icon}})]),_c('span',{staticClass:"ml-3 alarm-item__text"},[_vm._v(" "+_vm._s(_vm.item?.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }